<template>
	<div id="login-body">
		<div id="login">
			<el-row>
			    <el-col :span="12">
					<img :src="img|Ximgurl" class="loginImg" />
			    </el-col>
			    <el-col :span="12" style="background-color: #FFFFFF;">
					
				    <div class="loginrightBcg">
						<div class="loginrightBcg-header"></div>
						<div class="loginrightBcg-tab">
							<div :class="activtType==0?'activt':''">手机号码注册</div>
						</div>
						
						
						<div class="loginrightBcg-input" >
							<el-input
							  placeholder="用户名"
							  v-model="username"
							  clearable>
							</el-input>
							<el-input
							  placeholder="手机号码"
							  v-model="keyword"
							  clearable>
							</el-input>
							
							
						<!-- 	<div class="loginrightBcg-input-div">
								<el-input placeholder="验证码" v-model="code" ></el-input> 
								<el-button round size="mini" v-show="show" @click="getCode">获取验证码</el-button>
								<el-button round size="mini"  v-show="!show">{{count}} s</el-button>
							</div>
							 -->
							<el-input
							  placeholder="设置密码:6-16位字符,包含字母和数字"
							  v-model="password"
							  show-password
							  >
							</el-input>
							
							<div class="loginrightBcg-input-checkbox">
								<el-checkbox v-model="checked">我已阅读并同意<span @click="url('shequ')">《社区服务协议》</span><span @click="url('yinshi')">《隐私政策》</span></el-checkbox>
							</div>
							
						</div>
						
						
						<!-- <div v-if="activtType==1" style="color: rgba(217, 0, 27, 1); text-align: right; width: 92%;font-size: 12px;padding-top: 10px;">忘记密码？</div> -->
						
						<el-button @click="registerClick()" class="button1" type="danger" size="medium " round>注册</el-button>
						
						<div class="loginrightBcg-top">
							<span >已有账号？</span>
							<router-link to="/login">
							<span style="color: rgba(217, 0, 27, 1);">立即登录</span>
								</router-link>
						</div>
				    </div>
					
					
			    </el-col>
			</el-row>
		</div>
	</div>
	
</template>

<script>
	 export default {
	    data() {
	      return {
	        keyword: '',
			password : '',
			activtType:0,
			code : '',
			show: true,
			count: '',
			checked:'',
			img  : '',
			username : ''
	      }
	    },
		created() {
			let that = this;
			that.$http('get','/api/v1/config?name=login',{}) .then(function (res) {
				that.img = res.data; 
				console.log(res);
			});
		},
		methods:{
			tabClick(e){
				let that = this;
				if(e==1){
					that.message('暂时无开放','error');return;
				}else{
					that.activtType = e;
				}
				
			},
			message(msg,type){
				this.$message({
				    message: msg,
					showClose: true,
				    type: type
				});
				
			},
			url(e){
					this.$router.push('/agreement?name='+e);
			},
			registerClick(){
					let that = this;
					if(!that.keyword){
						that.message('手机号码不得为空','error');return;
					}
					if(!that.checked){
						that.message('请阅读并同意协议','error');return;
						
					}
					// if(!that.code){
					// 	that.message('验证码不得为空','error');return;
					// }
						that.$http('post','/api/v1/userlogin/register',{'mobile':that.keyword,'password':that.password,'username':that.username}) .then(function (response) {
							if(response.code==200){
								localStorage.setItem('token',response.data);
								that.message(response.msg,'success');
								that.$router.push('/');
								return;
							}else{
								that.message(response.msg,'error');return;
							}
							console.log(response);
						});
					
					
					
				console.log(2);
				//
			},
			 getCode(){
			     const TIME_COUNT = 60;
				 let that = this;
				 if(!that.keyword){
				 	that.message('手机号码/账号不得为空','error');return;
				 }
				 that.$http('post','/api/login/sms',{'phone':that.keyword}) .then(function (response) {
				 	if(response.code==1){
						 const TIME_COUNT = 60;
				 		if (!that.timer) {
				 		  that.count = TIME_COUNT;
				 		  that.show = false;
				 		  that.timer = setInterval(() => {
				 		  if (that.count > 0 && that.count <= TIME_COUNT) {
				 		    that.count--;
				 		   } else {
				 		    that.show = true;
				 		    that.timer = null;
				 		   }
				 		  }, 1000)
				 		 }
				 	}
				 });
			     
			}  
		}
	  }
</script>

<style lang="less">
	.el-col-12 {
		width: auto;
	}
	#login-body {
		background-color: rgba(245, 245, 250, 1);
		min-width: 900px;
		min-height: 100vh;
	
	}
	#login {
	  font-family: 'Avenir', Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	 
	  min-width: 900px;
	  margin-left: auto;
	  margin-right: auto;
	  padding-top: 60px;
	}
	.loginImg {
		/* width: 100%; */
		width: 450px;
		height: 500px;
		
	}
	.loginrightBcg {
			width: 450px;
		height: 500px;
		margin-left: auto;
		margin-right: auto;
	}
	.loginrightBcg-header {
		height: 80px;
	}
	.loginrightBcg-tab {
		height: 100px;
		display: flex;
		text-align: center;
		justify-content: center;
		color: #2c3e50a3;
	}
	.loginrightBcg-tab div {
		padding-left: 10px;
		padding-right: 10px;
		
	}
	.loginrightBcg-input input {
		display: block;
		margin-left: auto;
		margin-right: auto;
		border: none;
		height: 40px;
		width: 80%;
		border-radius: 0;
		border-bottom: 1px solid rgb(205 205 208);
		margin-top: 20px;
	}
	.loginrightBcg-input-div {
		width: 80%;
		margin-left: auto;
		margin-right: auto;
		display: flex;
		height: 45px;
		border-bottom: 1px solid rgb(205 205 208);
		margin-top: 20px;
	}
	.loginrightBcg-input-checkbox {
		padding-top: 10px;
		font-size: 10px;
		color: #000000;
		.el-checkbox__label {
			span {
				color:  rgba(217, 0, 27, 1);
			}
		}
		
		
	}
	.loginrightBcg-input-div input {
		border: none;
		width: auto;
		flex: 2;
		margin-left: 0px;
		margin-top: 0;
	}
	.loginrightBcg-input-div button {
		margin-top: px;
		height: 34px;
	}
	.button1 {
		height: 40px;
		width: 180px;
		margin-top: 20px !important;
		background-color: rgba(217, 0, 27, 1) !important;
	}
	.loginrightBcg-top {
		padding-top: 10px;
		color: #2c3e50a3;
		
	}

	.activt {
		 color: #2c3e50;
	}
	.activt:after{ content:""; width:2rem; height:2px; background-color: red; margin:0 auto 0 auto; display:block; margin-top: 3px; }

	 .el-row {
	    margin-bottom: 20px;
	    &:last-child {
	      margin-bottom: 0;
	    }
	  }
	  .el-col {
	    border-radius: 4px;
	  }
	  .bg-purple-dark {
	    background: #99a9bf;
	  }
	  .bg-purple {
	    background: #d3dce6;
	  }
	  .bg-purple-light {
	    background: #e5e9f2;
	  }
	  .grid-content {
	    border-radius: 4px;
	    min-height: 36px;
	  }
	  .row-bg {
	    padding: 10px 0;
	    background-color: #f9fafc;
	  }
</style>
